'use client';

import { useEffect } from 'react';

import { getCurrency } from '@/app/currency';

import { ENV } from '@shared/config';
import { Notes } from '@shared/types';

type Props = {
  notes?: Notes[] | null;
  list?: string;
  category?: string;
};

export const PopularMetrika = ({ notes, list, category }: Props) => {
  useEffect(() => {
    void (async () => {
      // eslint-disable-next-line @typescript-eslint/await-thenable
      const currency = await getCurrency();

      if (notes?.length) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
        window.dataLayer.push({
          ecommerce: {
            currencyCode: currency?.value || ENV.DEFAULT_CERRENCY,
            impressions: notes.map(({ id, title, musicians, arrangement, instruments }, index) => ({
              id: id.toString(),
              name: `${musicians[0]?.title} - ${title} - ${arrangement?.title}`,
              position: index + 1,
              list,
              category: arrangement?.title,
              brand: instruments?.[0]?.title,
            })),
          },
        });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, category]);

  return null;
};
